import { render, staticRenderFns } from "./bankPaymentCode.vue?vue&type=template&id=51f38516&scoped=true"
import script from "./bankPaymentCode.vue?vue&type=script&lang=js"
export * from "./bankPaymentCode.vue?vue&type=script&lang=js"
import style0 from "./bankPaymentCode.vue?vue&type=style&index=0&id=51f38516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f38516",
  null
  
)

export default component.exports